<template>
  <v-flex md7>
    <instruction-form
      v-if="modalVisible"
      :instruction-id="instructionId"
      :modal-visible="modalVisible"
      @close="closeEdit"
    />
    <page-toolbar>
      <period-control @change="periodChange" :showAllYearItem="true" :showAllPeriodItem="true">
      </period-control>
    </page-toolbar>
    <kendo-grid
      height="calc(100vh - 145px)"
      :dataSource="dataSource"
      :editable="false"
      ref="grid"
      :filterable="true"
      :sortable="true"
      :pageable-always-visible="true"
      :columns="columns"
      :autoBind="false"
    >
    </kendo-grid>
  </v-flex>
</template>
<script>
import {mapGetters} from 'vuex'
import PeriodControl from '@/components/PeriodControl'
import PageToolbar from '@/components/PageToolbar'
import {enableExportExcel} from '@/helpers/export-helper'
import {getDataItem} from '@/helpers/kendo-helpers'
import InstructionForm from '@/components/Clients/Heroux/InstructionForm'
import security from '@/mixins/security'

const $ = kendo.jQuery

export default {
  mixins: [security],
  mounted() {
    let grid = this.$refs.grid.kendoWidget()

    grid.element.on('click', '.dealCodeLink', e => {
      const dataItem = getDataItem(e.target)
      this.modalVisible = true
      this.instructionId = dataItem.instructionId
    })
    enableExportExcel(grid, '/api/heroux/Instruction/exportToExcel', $('.page_toolbar-item'))
  },
  data() {
    return {
      startDate: null,
      endDate: null,
      instructionId: null,
      modalVisible: false,
      columns: [
        {
          field: 'instructionId',
          title: 'Number',
          width: 100,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
          template: kendo.template(
            '<a href="javascript:;" class="dealCodeLink">#=instructionId#</a>',
          ),
        },
        {
          field: 'sectorName',
          title: 'Sector',
          width: 90,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'counterpartyCode',
          title: 'Counterparty',
          width: 150,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'instructionDate',
          title: 'Instruction Date',
          width: 120,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
        },
        {
          field: 'accountCode',
          title: 'Account CCY1',
          width: 110,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
        },
      ],
      dataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 30,
        transport: {
          read: {
            type: 'GET',
            url: '/api/heroux/Instruction',
            data: () => ({
              clientId: this.clientId,
              startDate: this.startDate,
              endDate: this.endDate,
            }),
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'instructionId',
            fields: {
              instructionId: {type: 'number'},
              sectorName: {type: 'string', field: 'sectorName', editable: false},
              counterpartyCode: {type: 'string', field: 'counterpartyCode', editable: false},
              instructionDate: {type: 'date', field: 'instructionDate'},
              accountCode: {type: 'string', field: 'accountCode', editable: false},
            },
          },
        },
      }),
    }
  },
  methods: {
    closeEdit() {
      this.dataSource.read()
      this.instructionId = null
      this.modalVisible = false
    },
    periodChange(e) {
      this.startDate = e.startDate
      this.endDate = e.endDate
      this.dataSource.read()
    },
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
  },
  components: {
    PageToolbar,
    PeriodControl,
    InstructionForm,
  },
}
</script>
